'use strict';
/**
 * A service to get and edit tracked moods on the site
 */

angular.module('msTracker').service('moodTrackerDataMappingSvc', [function () {

  return {
    filterForDateRange: filterForDateRange,
    mapMoodsForSaving: mapMoodsForSaving,
    mapSingleTrackerEntriesByDay: mapSingleTrackerEntriesByDay,
    mapEntries: mapEntries,
    mapOldMoodScalingToNewScaling: mapOldMoodScalingToNewScaling
  };

  ///////////////////

  function filterForDateRange(trackerData, startDate, endDate) {
    return _.filter(trackerData, function (entry) {
      return moment(entry.createdOn).isBetween(startDate, endDate);
    });
  }

  function mapSingleTrackerEntriesByDay(arrayOfTrackerData) {
    var uniqueDays = _.uniqBy(arrayOfTrackerData, function (entry) {
      return moment(entry.createdOn).format('L');
    });
    var mappedEntries = {};
    uniqueDays.forEach(function (entryWithUniqDay) {
      var thisDayFormatted = moment(entryWithUniqDay.createdOn).format('LL');
      var matchedDays = arrayOfTrackerData.filter(function (entry) {
        return moment(entry.createdOn).format('LL') === thisDayFormatted;
      });
      mappedEntries[thisDayFormatted] = matchedDays;
    });
    return mappedEntries;
  }

  function mapEntries(trackerData) {

    var mappedEntries = {};

    trackerData.forEach(function (tracker) {
      tracker.trackerEntries.forEach(function (entry) {

        var entryDate = moment(entry.createdOn);
        var mappedMoodEntry = {
          value: entry.value,
          datetime: entryDate,
          entryId: entry.entryId,
          id: entry.sliderId,
          position: tracker.position
        };

        var dayEntry = {
          datetime: entryDate,
          data: {}
        };

        var entryOnThisDateExists = !_.isUndefined(mappedEntries[moment(entryDate).startOf('day').unix()]);

        if (entryOnThisDateExists) {

          var timestampOnThisDateMinuteExists = !_.isUndefined(mappedEntries[moment(entryDate).startOf('day').unix()].data[entryDate.unix()]);

          if (!timestampOnThisDateMinuteExists) {
            mappedEntries[moment(entryDate).startOf('day').unix()].data[entryDate.unix()] = {
              message: entry.message,
              values: [mappedMoodEntry],
              datetime: entryDate,
              localizedDatetime: entryDate.unix()
            };
          } else {
            mappedEntries[moment(entryDate).startOf('day').unix()].data[entryDate.unix()].values.push(mappedMoodEntry);
          }
          mappedEntries[moment(entryDate).startOf('day').unix()].data[entryDate.unix()].values = _.sortBy(mappedEntries[moment(entryDate).startOf('day').unix()].data[entryDate.unix()].values, 'position');
        } else {
          dayEntry.data[entryDate.unix()] = {
            messageId: entry.messageId,
            message: entry.message,
            values: [mappedMoodEntry],
            datetime: entryDate,
            localizedDatetime: entryDate.unix()
          };
          mappedEntries[moment(entryDate).startOf('day').unix()] = dayEntry;
        }
        mappedEntries[moment(entryDate).startOf('day').unix()].data = _.reverseKeysBy(mappedEntries[moment(entryDate).startOf('day').unix()].data, function (value, key) {
          return key;
        });
      });
    });

    mappedEntries = cleanUpLabels(mappedEntries);

    // reverse the array to get the newest up top.
    return _.values(mappedEntries).reverse();
  }

  // If there is only one entry on the minute, record the localized time without the seconds
  // If two entries were recorded in the same minute, add the seconds to the localized time.
  function cleanUpLabels(trackerEntriesMapped) {
    _.values(trackerEntriesMapped).forEach(function (day) {
      var uniqueTimes = [];
      _.map(day.data, function (entry, unixTimeString) {
        var momentTime = moment(parseInt(unixTimeString * 1000));
        if (!_.includes(uniqueTimes, momentTime.format('LT'))) {
          uniqueTimes.push(momentTime.format('LT'));
          entry.localizedDatetime = momentTime.format('LT');
        } else {
          day.data[unixTimeString].localizedDatetime = momentTime.format('LTS');
          var time = momentTime.format('LT');
          var matchedTime = _.findKey(day.data, { 'localizedDatetime': time });
          if (matchedTime) {
            day.data[matchedTime].localizedDatetime = day.data[matchedTime].datetime.format('LTS');
          }
        }
      });
      // Sort each day's data by time (newest up top)
      day.data = _.sortBy(day.data, function (entry) {
        return -entry.datetime;
      });
    });
    return trackerEntriesMapped;
  }

  function mapMoodsForSaving(moodValues) {
    var results = [];
    moodValues.forEach(function (part, index, arr) {
      results.push({ id: arr[index].tracker.id, entryId: arr[index].tracker.entryId, moodValue: arr[index].value });
    });
    return results;
  }

  function mapOldMoodScalingToNewScaling(data) {
    data.forEach(function (tracker) {
      tracker.trackerEntries.forEach(function (part, index, arr) {
        //change the 0-100 scale to -1 to +1
        part.mood = Math.round(part.mood / 25) * 25;
        arr[index].value = (part.mood - 50) / 50;
        arr[index].datetime = moment(part.createdOn);
      });
    });
    return data;
  }
}]);